import * as React from "react"
import {connect} from "react-redux"
import trans from "trans"
import { PreviewsForm } from 'template-previews/types'

import {
    Checkbox,
    Grid,
    GridCell,
    Select,
    css,
} from "@bdfx/mergado-ui-kit"

import { selectFormValues, updateInputValue as change } from "app/reducers/form"

interface Props {
    change: typeof change
    previewsForm: PreviewsForm
    updatePreviews: Function
}

class Togglers extends React.Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    render() {
        const optionsItemsPerPage = [3, 4, 6, 8, 9, 12, 16, 18, 24, 32].map((o : number) => ({label: `${o}`, value: `${o}`}))

        return (
            <StyledTogglersGrid>
                <GridCell>
                    <Checkbox
                        name='previewsForm.view.active'
                        label={trans("active_only")}
                        onChange={() => this.props.updatePreviews(this.props.previewsForm)}
                    />
                </GridCell>
                <GridCell>
                    <Checkbox
                        name='previewsForm.view.rawImages'
                        label={trans("unmodified_images")}
                        onChange={() => this.props.updatePreviews(this.props.previewsForm)}
                    />
                </GridCell>
                <GridCell>
                    <Checkbox
                        label={trans("allow_cache")}
                        name='previewsForm.view.allowCache'
                        onChange={() => this.props.updatePreviews(this.props.previewsForm)}
                    />
                </GridCell>
                <GridCell>
                    <Grid className={'products-per-page-grid'}>
                        <GridCell><span style={{marginRight: '20px'}}>{trans('products_per_page')}</span></GridCell>
                        <GridCell><Select
                            options={optionsItemsPerPage}
                            value={`${this.props.previewsForm.view.itemsPerPage}`}
                            onChange={(e) => {
                                const updatedPreviewsForm = {
                                    ...this.props.previewsForm,
                                    view: {
                                        ...this.props.previewsForm.view,
                                        itemsPerPage: e,
                                    }
                                }

                                this.props.change('previewsForm', 'view.itemsPerPage', e)
                                this.props.updatePreviews(updatedPreviewsForm)
                            }}
                        /></GridCell>
                    </Grid>
                </GridCell>
            </StyledTogglersGrid>
        )
    }
}

const StyledTogglersGrid = css(Grid)({
    padding: 0,
    margin: 0,
    whiteSpace: 'nowrap',
    lineHeight: '30px',
    fontSize: '16px',
    verticalAlign: 'center',
    alignSelf: 'center',
    justifyContent: 'space-between',
    gridTemplateColumns: 'repeat(4, 1fr)',
    '.muk-checkbox-wrapper': {
        marginBottom: '0px !important',
    },
    ' .muk-button': {
        padding: '4px 10px',
    },
    ' .muk-form-group': {
        margin: 0,
        padding: 0,
    },
    ' .muk-gridcell': {
        minHeight: '32px',
        alignSelf: 'end',
    },
    ' .products-per-page-grid': {
        gridTemplateColumns: 'auto 110px',
    },
    '@media screen and (max-width: 1024px)': {
        gridTemplateColumns: 'auto',
        ' .products-per-page-grid': {
            gridTemplateColumns: 'auto',
        },
    },
})

function mapStateToProps(state) {
    return {
        previewsForm: selectFormValues(state, 'previewsForm'),
    }
}

export default connect(mapStateToProps, {
    change,
})(Togglers)